import { Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject, Observable } from 'rxjs';
import { MenuConfig } from '../../features/main-menu/main-menu/menu-config';

@Injectable({ providedIn: "root" })
export class MenuConfigService {
  private historySubject: BehaviorSubject<string[]>;
  public history: Observable<string[]>;

  private navigationDataSubject: BehaviorSubject<MenuConfig | null>;
  public navigationData: Observable<MenuConfig | null>;

  constructor(private router: Router, private location: Location) {

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let value = this.historySubject.getValue();
        value.push(event.urlAfterRedirects);
        this.historySubject.next([...new Set(value)]);
      }
    });

    this.historySubject = new BehaviorSubject<string[]>([]);
    this.history = this.historySubject.asObservable();

    this.navigationDataSubject = new BehaviorSubject<MenuConfig | null>(null);
    this.navigationData = this.navigationDataSubject.asObservable();
  }

  public setData(data: MenuConfig) {
    this.navigationDataSubject.next(data);
  }

  public resetHistory() {
    this.historySubject.next([]);
  }

  back(): void {
    let value = this.historySubject.getValue();
    value.pop();
    if (value.length > 0) {
      this.location.back();
    }
  }
}
